module.exports = __webpack_public_path__ + "img/BE0404055577.5144bd85.png";